const applyDefaultWorkbookView = workbook => {
  workbook.views = [{
    x: 0,
    y: 0,
    width: 36000,
    height: 18000,
    firstSheet: 0,
    activeTab: 0,
    visibility: 'visible'
  }]
}

export default applyDefaultWorkbookView
